import { supportMailto } from "@/lib/support-contact";
import { messengerLive } from "./messenger-visibility";

type IntercomWidget = { (command: "show"): void; booted?: boolean };

function intercomWidget(): IntercomWidget | undefined {
  return (window as { Intercom?: IntercomWidget }).Intercom;
}

export function intercomBooted(): boolean {
  return intercomWidget()?.booted === true;
}

export function openSupportChat(subject?: string): "intercom" | "email" {
  const intercom = intercomWidget();
  if (intercom?.booted === true && messengerLive()) {
    intercom("show");
    return "intercom";
  }
  window.location.href = supportMailto(subject);
  return "email";
}
